.page {
  display: flex;
  justify-content: center;
  min-height: 100dvh;
  padding: 48px var(--gutter);
  background: var(--bg);
}

.column {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 480px;
  max-width: 100%;
}

.title {
  font-size: 24px;
}

.tagline {
  margin: 4px 0 0;
  color: var(--text-muted);
}

.notice {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 14px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
}

.notice p {
  margin: 0;
}

.linkButton {
  align-self: flex-start;
  padding: 0;
  border: 0;
  background: none;
  color: var(--accent, var(--text));
  text-decoration: underline;
  cursor: pointer;
}

.error {
  color: var(--danger);
  font-size: var(--font-size-sm);
}

.card {
  padding: 20px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
}

.pending {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.localEntry {
  display: flex;
  justify-content: center;
}
